module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-01.3b427dc.webp";